import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_partyIdAdapter2v7zx778kk10s as get_partyIdAdapter } from '../../../adapter/Adapter.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { DeletePartyInput19hgu5jgthqub as DeletePartyInput } from '../DeletePartyInput.mjs';
import { Adapter1t72m9xaryzfb as Adapter } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapter.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DeletePartyInput_InputAdapterClass;
function DeletePartyInput_InputAdapter() {
  if (DeletePartyInput_InputAdapterClass === VOID) {
    class $ {
      p40(reader, customScalarAdapters) {
        throw IllegalStateException().o('Input type used in output position');
      }
      i6x(writer, customScalarAdapters, value) {
        writer.l4d('partyId');
        get_partyIdAdapter().q40(writer, customScalarAdapters, value.v6t_1);
      }
      q40(writer, customScalarAdapters, value) {
        return this.i6x(writer, customScalarAdapters, value instanceof DeletePartyInput() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'DeletePartyInput_InputAdapter', VOID, VOID, [Adapter()]);
    DeletePartyInput_InputAdapterClass = $;
  }
  return DeletePartyInput_InputAdapterClass;
}
var DeletePartyInput_InputAdapter_instance;
function DeletePartyInput_InputAdapter_getInstance() {
  return DeletePartyInput_InputAdapter_instance;
}
//region block: init
DeletePartyInput_InputAdapter_instance = new (DeletePartyInput_InputAdapter())();
//endregion
//region block: exports
export {
  DeletePartyInput_InputAdapter_instance as DeletePartyInput_InputAdapter_instancemwdbvrhinm6l,
};
//endregion

//# sourceMappingURL=DeletePartyInput_InputAdapter.mjs.map
